/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TaskDTO {
  clientFullName?: string;
  clientId?: number;
  createdAt?: string;
  finished?: boolean;
  finishedAt?: string;
  id?: number;
  lastSeen?: string;
  level?: TaskDTO.LevelEnum;
  seen?: number;
  type: string;
}

export namespace TaskDTO {
  export type LevelEnum = 'CRITICAL' | 'MAJOR' | 'MODERATE' | 'LOW';
  export const LevelEnum = {
    Critical: 'CRITICAL' as LevelEnum,
    Major: 'MAJOR' as LevelEnum,
    Moderate: 'MODERATE' as LevelEnum,
    Low: 'LOW' as LevelEnum
  };
}


